import { WebGLRenderer } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { KTX2Loader } from "three/examples/jsm/loaders/KTX2Loader.js";


// It is recommended to always pull your Draco JavaScript and WASM decoders
// from this URL. Users will benefit from having the Draco decoder in cache
// as more sites start using the static URL.
// const dracoLoader = new DRACOLoader().setDecoderPath('https://www.gstatic.com/draco/versioned/decoders/1.4.1/');

// const gltfLoader = new GLTFLoader().setCrossOrigin('anonymous').setDRACOLoader(dracoLoader);
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath('https://d1mfzu0xo6h6ih.cloudfront.net/designer/draco/1.5.6/');
dracoLoader.setCrossOrigin('anonymous');
dracoLoader.preload();
export const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);
gltfLoader.setCrossOrigin('anonymous');

const ktx2Loader = new KTX2Loader();
ktx2Loader.setTranscoderPath('https://d1mfzu0xo6h6ih.cloudfront.net/designer/ktx2/7ce26e9/');
const renderer = new WebGLRenderer();
ktx2Loader.detectSupport( renderer );
gltfLoader.setKTX2Loader(ktx2Loader);

/**
 * Utility function to add a suffix to a URL string.
 * Handles cases where the URL may start with '//' and ensures proper concatenation of the suffix.
 *
 * @param urlStr - The original URL string to which the suffix will be added.
 * @param suffix - The suffix to be added to the URL's path.
 * @returns A new URL string with the suffix added.
 */
export function addSuffixToUrl(urlStr: string, suffix: string) {
  // Parse URL and add suffix to the path
  if (urlStr.startsWith('//')) urlStr = `https:${urlStr}`;
  const url = new URL(urlStr);

  // We only want to ensure no double slashes, but if the suffix is an extension (e.g., .png)
  // we might just want to concatenate directly. Given standard usage, appending is best done safely:
  if (suffix.startsWith('.')) {
    url.pathname += suffix;
  } else if (url.pathname.endsWith('/') && suffix.startsWith('/')) {
    url.pathname += suffix.slice(1);
  } else if (!url.pathname.endsWith('/') && !suffix.startsWith('/')) {
    url.pathname += '/' + suffix;
  } else {
    url.pathname += suffix;
  }

  return url.toString();
}
